/*
  MediaQueryPlugin

  ie:
    :class="[M.lg ? 'class-lg' : 'class-other']"
*/
const plugin = {};
const matchMedia = window.matchMedia;

plugin.install = function (Vue) {
  const resolutions = {
    lg: '(min-width: 1366px)',
  };

  const data = _.reduce(
    resolutions,
    (a, v, k) => {
      a['_' + k] = null;
      return a;
    },
    {}
  );

  Vue.prototype.M = new Vue({
    created() {
      _.forEach(resolutions, (v, k) => {
        const mediaQueryList = matchMedia(v);
        data['_' + k] = mediaQueryList.matches;
        mediaQueryList.addListener(this['@' + k]);
      });
    },
    data,
    computed: _.reduce(
      resolutions,
      (a, v, k) => {
        a[k] = () => {
          return data['_' + k];
        };
        return a;
      },
      {}
    ),
    methods: Object.assign(
      _.reduce(
        resolutions,
        (a, v, k) => {
          a['@' + k] = (e) => {
            data['_' + k] = e.matches;
          };
          return a;
        },
        {}
      ),
      {
        isMatched(resolution) {
          return matchMedia(resolution).matches;
        },
      }
    ),
  });
};

export default plugin;
